import styled, { css } from 'styled-components';
import colours from 'theme/atoms/colours';
import { profileTagBase } from 'shiftNotes/styles/ProfileTag.style';

const defaultEditableTypography = css`
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 650;
  line-height: 28px;
  letter-spacing: -0.48px;
`;

const defaultMentionChip = css`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0 3px;
  background-color: ${colours.neutral[200]};
  border-radius: 5px;
  font-weight: 650;
  cursor: pointer;
  color: ${colours.neutral[700]};
  height: 26px;

  svg {
    stroke-width: 2;
  }

  svg path {
    stroke: ${colours.neutral[700]};
  }

  .mention-icon {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    margin-bottom: 3px;
  }

  .mention-icon-user svg path {
    fill: ${colours.neutral[700]};
  }
`;

const compactMentionChip = css`
  ${profileTagBase}
  display: inline;

  svg {
    width: 0.9em;
    height: 0.9em;
  }

  .mention-icon {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    margin-right: 0.15em;
  }

  .mention-icon-user svg path {
    fill: ${colours.blue[500]};
  }
`;

const EditableContent = styled.div<{ $compact?: boolean }>`
  white-space: pre-wrap;
  width: 100%;
  color: #001d25;
  cursor: text;

  ${({ $compact }) => !$compact && defaultEditableTypography}

  /* Mention chips inside the editor */
  .mention-chip {
    ${({ $compact }) => ($compact ? compactMentionChip : defaultMentionChip)}
  }

  p {
    margin: 0;
  }
`;

export default EditableContent;
